import {ChangeDetectionStrategy, Component, ViewEncapsulation, forwardRef, input } from "@angular/core";
import { InputFormWrapper } from "../wrapper.interface";
import { InputSwitchConfig } from "./inputSwitch.config";
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { SharedModule } from "primeng/api";
import { ToggleSwitchModule } from "primeng/toggleswitch";
import { V_FORM_CONTROL_TOKEN, WRAPPER_TOKEN } from "../wrapper.tokens";
import { TranslateModule } from "@ngx-translate/core";
import { GcColumnContainerComponent } from "src/app/components/v-layout/column/column.component";

/**
 * TODO: Discuss if we should rename it to ToggleSwitch instead of InputSwitch
 */
@Component({
    selector:      'v-input-switch',
    templateUrl:   './inputSwitch.component.haml',
    encapsulation: ViewEncapsulation.None,
    styleUrls:     ['./inputSwitch.component.sass', '../input.style.sass', '../style.sass'],
    providers:     [
        { provide: V_FORM_CONTROL_TOKEN, useExisting: forwardRef(() => VInputSwitchComponent) },
        { provide: WRAPPER_TOKEN, useExisting: forwardRef(() => VInputSwitchComponent) },
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => VInputSwitchComponent), multi: true }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports:         [CommonModule, ToggleSwitchModule, ReactiveFormsModule, SharedModule, TranslateModule, GcColumnContainerComponent]
})
export class VInputSwitchComponent<TTrue = true, TFalse = false> extends InputFormWrapper<InputSwitchConfig, TTrue | TFalse> {
    protected readonly _baseConfig: InputSwitchConfig = InputSwitchConfig.baseTheme.Default;

    public trueValue? = input<TTrue>(true as TTrue);
    public falseValue = input<TFalse | null | undefined>(false as TFalse);
}